import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { HeaderBreadcrumbService } from 'src/app/components/header-components/header-breadcrumb/header-breadcrumb.service';
import { Breadcrumb } from 'src/app/models/breadcrumb-models/breadcrumb-model/breadcrumb.model';
import { BRoute } from 'src/app/models/breadcrumb-models/breadcrumb-route-model/breadcrumb-route.model';
import { FormsTurnsService } from 'src/app/services/turns-services/forms-turns-service/forms-turns.service';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-turns-forms-dashboard',
  templateUrl: './turns-forms-dashboard.component.html',
  styleUrls: ['./turns-forms-dashboard.component.scss']
})
export class TurnsFormsDashboardComponent implements OnInit {

  forms;
  filterKey;
  filterOpts;
  noItemsConfig;
  viewDisposition = 'grid';
  getFormsSubscription: Subscription;
  filterFormsSubscription: Subscription;
  refreshFormsSubscription: Subscription;
  searchFormsSubscription: Subscription;
  toggleFormsDispositionSubscription: Subscription;

  constructor(private headerBreadcrumbService: HeaderBreadcrumbService,
              private formsTurnsService: FormsTurnsService,
              private cd: ChangeDetectorRef,
              private snackbarService: SnackBarService) {
                this.noItemsConfig = this.setNoItemsConfig();
              }

  ngOnInit() {
    this.setBreadcrumb();
    this.getForms();
    this.refreshFormsSubscription = this.formsTurnsService.refreshFormsListen().subscribe(
      (res) => {
        this.getForms();
      }
    );
    this.filterFormsSubscription = this.formsTurnsService.filterFormsListen().subscribe(
      (res) => {
        this.filterOpts = res;
        this.cd.detectChanges();
      }
    );
    this.searchFormsSubscription = this.formsTurnsService.searchFormsListen().subscribe(
      (res) => {
        this.filterKey = res;
      }
    );
    this.toggleFormsDispositionSubscription = this.formsTurnsService.toggleFormsDispositionListen().subscribe(
      (res) => {
        this.viewDisposition = res;
      }
    );
  }

  private getForms() {
    this.getFormsSubscription = this.formsTurnsService.getForms().subscribe(
      (res) => {
        if (res) {
          this.forms = res;
        }
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  private setBreadcrumb() {
    this.headerBreadcrumbService.setRoutes(new Breadcrumb('fas fa-file-alt', 'turns-page.forms', '/turns', [new BRoute('turns-page.turns', '/turns'), new BRoute('turns-page.forms')]));
  }

  private setNoItemsConfig() {
    return {
      description: 'turns-page.forms not found',
      action: '',
      lottieConfig: {
        path: 'assets/lottie-animations/empty-list.json',
        renderer: 'canvas',
        autoplay: true,
        loop: true
      }
    };
  }

  ngDestroy() {
    if (this.getFormsSubscription) { this.getFormsSubscription.unsubscribe(); }
    if (this.refreshFormsSubscription) { this.refreshFormsSubscription.unsubscribe(); }
    if (this.searchFormsSubscription) { this.searchFormsSubscription.unsubscribe(); }
    if (this.filterFormsSubscription) { this.filterFormsSubscription.unsubscribe(); }
  }
}
